import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>Around The World</h1>
            </header>
            <div className="content">
                <p>Welcome to The World's  Tourist Site,<br />
                Take a breathe and Enjoy !</p>
                <ul className="actions">
                    <li><a href="/landing" className="button next scrolly">Start Exploring</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
